<template>
    <info-screen
            :title="$ml.get('errorUserAlreadyExistTitle')"
            :text="$ml.get('errorUserAlreadyExistDescr')"
            :headerImg="5"
    >
        <template slot="bottom">
            <div class="left">
                <custom-button
                        :button-text="$ml.get('back')"
                        back
                        :action="back"
                ></custom-button>
            </div>
            <div class="right">
                <custom-button
                        ref="nextBtn"
                        :button-text="$ml.get('goToLogin')"
                        success
                        :action="goToLogin"
                ></custom-button>
            </div>
        </template>
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import Profile from '../../helpers/profile'
    import {resendSms, sendCodeByCall} from '../../helpers/api'
    import CustomButton from "../../components/ui/custom-button.vue";

    export default {
        name: "sendCodePage",
        components: {
            CustomButton,
            InfoScreen},

        methods: {
            goToLogin: function () {
                this.$router.push({name: 'LoginEnterLogin'});
            },

            back: function () {
                this.$router.back();
            }
        }

    }
</script>

<style lang="scss" scoped>
    .callWrap {
        text-align: center;
        padding-bottom: 10px;
    }
    .enterCodeScreen_call {
        cursor: pointer;
        font-size: 16px;
    }
</style>